const DEFAULT_CENTER = {
	lat: 37.7749,
	lng: -122.4194,
};

const DEFAULT_ZOOM = 10;

export function initServiceAreaMapBlocks() {
	const maps = document.querySelectorAll('[data-service-area-map]');
	if (!maps.length) {
		return;
	}

	if (!window.L || typeof window.L.map !== 'function') {
		return;
	}

	maps.forEach((mapElement) => {
		initServiceAreaMap(mapElement);
	});
}

function initServiceAreaMap(mapElement) {
	const centerLat = parseFloatValue(mapElement.dataset.centerLat, DEFAULT_CENTER.lat);
	const centerLng = parseFloatValue(mapElement.dataset.centerLng, DEFAULT_CENTER.lng);
	const zoom = parseIntValue(mapElement.dataset.zoom, DEFAULT_ZOOM);
	const markers = parseMarkers(mapElement.dataset.markers);
	const pinUrl = mapElement.dataset.pinUrl || '';

	const map = window.L.map(mapElement, {
		zoomControl: false,
		scrollWheelZoom: false,
	});

	window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '&copy; OpenStreetMap contributors',
		maxZoom: 20,
	}).addTo(map);

	const markerIcon = createMarkerIcon(pinUrl);

	if (markers.length) {
		markers.forEach((markerData) => {
			const marker = window.L.marker([markerData.lat, markerData.lng], { icon: markerIcon });
			marker.addTo(map);

			if (markerData.title) {
				marker.bindPopup(markerData.title);
			}
		});
	}

	map.setView([centerLat, centerLng], zoom);

	// Prevent initial tile clipping in hidden/just-mounted containers.
	requestAnimationFrame(() => {
		map.invalidateSize();
	});
}

function createMarkerIcon(pinUrl) {
	if (!pinUrl) {
		return new window.L.Icon.Default();
	}

	return window.L.icon({
		iconUrl: pinUrl,
		iconSize: [68, 68],
		iconAnchor: [34, 62],
		popupAnchor: [0, -56],
	});
}

function parseMarkers(value) {
	if (!value) {
		return [];
	}

	try {
		const parsed = JSON.parse(value);
		if (!Array.isArray(parsed)) {
			return [];
		}

		return parsed
			.map((item) => {
				if (!item || typeof item !== 'object') {
					return null;
				}

				const lat = parseFloatValue(item.lat, null);
				const lng = parseFloatValue(item.lng, null);
				if (lat === null || lng === null) {
					return null;
				}

				return {
					lat,
					lng,
					title: typeof item.title === 'string' ? item.title.trim() : '',
				};
			})
			.filter(Boolean);
	} catch (error) {
		return [];
	}
}

function parseFloatValue(value, fallback) {
	const parsed = Number.parseFloat(String(value));
	return Number.isFinite(parsed) ? parsed : fallback;
}

function parseIntValue(value, fallback) {
	const parsed = Number.parseInt(String(value), 10);
	return Number.isFinite(parsed) ? parsed : fallback;
}
